// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__gk3ML","sm":"Divider_sm__yIvcE","lg":"Divider_lg__cRGJX"};